import setTitleCase from './setTitleCase';
import formatNameCaseWithSplitterAndSpacer from './formatNameCaseWithSplitterAndSpacer';
import getStateFromAbbr from './getStateFromAbbr';
/**
 * Convert address pieces from search params into a formatted string for display.
 * Hyphens/underscores in street and city params are turned into spaces, then
 * values are trimmed so trailing separators from padded URL slugs are removed.
 *
 * @param {object} opts
 * @param {string} opts.streetRaw - Street slug/param (hyphens → spaces)
 * @param {string} opts.cityRaw - City slug/param (underscores/hyphens → spaces)
 * @param {string} opts.stateAbbrRaw
 * @param {string} [opts.zipCode]
 * @param {boolean} [opts.useFullStateName]
 * @returns {string}
 */
const formatFullAddressFromParams = (opts = {}) => {
  if (!opts || !opts.streetRaw || !opts.cityRaw || !opts.stateAbbrRaw) {
    return '';
  }

  const { streetRaw, cityRaw, stateAbbrRaw, zipCode, useFullStateName } = opts;

  const street = setTitleCase({
    text: streetRaw.replace(/-/g, ' ').trim()
  })
    .replace(/Po|P\/O/, 'PO')
    .replace('|', '#');
  const state = useFullStateName
    ? getStateFromAbbr({
        stateAbbr: stateAbbrRaw.toUpperCase(),
        includeTerritories: true
      })
    : stateAbbrRaw.toUpperCase();
  const city = formatNameCaseWithSplitterAndSpacer({
    name: cityRaw.replace(/_|-/g, ' ').trim()
  });
  let address = `${street}, ${city}, ${state}`;
  if (zipCode) {
    return `${address} ${zipCode}`;
  }
  return address;
};

export default formatFullAddressFromParams;
